module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "info"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('tryBtn'), _vm._v(" "), _c('gallery', {
    staticStyle: {
      "padding-top": "50px"
    },
    attrs: {
      "isTop": _vm.boolTop
    }
  })], 1), _vm._v(" "), _vm._l((_vm.services), function(service) {
    return _c('div', {
      staticClass: "col-md-12 col-sm-12"
    }, [_c('div', {
      staticClass: "media",
      staticStyle: {
        "padding-left": "10%"
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "media-body wow fadeIn"
    }, [_c('h3', {
      staticClass: "media-heading primary"
    }, [_vm._v(_vm._s(service.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(service.info))])])])])
  })], 2), _vm._v(" "), _c('tryBtn')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('h1', {
    staticStyle: {
      "color": "#58585a",
      "text-align": "center"
    }
  }, [_vm._v("Printer Counters")]), _vm._v(" "), _c('h2', {
    staticStyle: {
      "color": "#58585a",
      "text-align": "center"
    }
  }, [_vm._v("\n          Your advanced Print Counter System for\n        ")]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "color": "#58585a",
      "text-align": "center"
    }
  }, [_vm._v("Network and Local Printers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-object media-left wow fadeInLeft",
    attrs: {
      "data-wow-delay": "0.2s"
    }
  }, [_c('i', {
    staticClass: "fa fa-diamond"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f8f913a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/info.vue
// module id = 699
// module chunks = 0